import { VuexClass } from '@averjs/vuex-decorators';
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {
    formModeEnum
} from "./models/DamageClaimModel";
import type {
    DamageCodesDictionary,
    CertificateCodesDictionary,
    DamageClaimRecord,
    PcertItem,
    CertigrafPlot,
    ProductMap,
    DamageClaimEvent,
    DamageClaimPhotos,
} from "./models/DamageClaimModel";
import type {
    CertigrafPrecertificateData,
    CertigrafOrganizationsDictionary,
} from "./models/CertigrafModel";
import { SignUserData } from "./models/CertigrafModel";

@VuexClass
export default class MainStateModule extends AbacoVuexModule {
    /**
     * Stepper & Form
     */
    @State() curStep!: number;
    @State({ default: 0 }) lastStep!: number;
    @State({ default: formModeEnum.NEW }) formMode!: formModeEnum;

    /**
     * User
     */
    @State({
        default: {
            name: '',
            surname: '',
            telephone: '',
            email: ''
        }
    }) userData!: SignUserData;
    @State({ default: false }) isCondifesaMode!: boolean;
    @State({ default: false }) isIntermediaryMode!: boolean;

    /**
     * Dictionaries
     */
    @State({ default: null }) certificateCodesDictionary!: CertificateCodesDictionary | null;
    @State({ default: null }) damageCodesDictionary!: DamageCodesDictionary | null;
    @State({ default: null }) organizationsDictionary!: CertigrafOrganizationsDictionary | null;

    /**
     * Records
     */
    @State({ default: {} }) dclaimRecords!: Record<string, DamageClaimRecord>;
    @State({ default: {} }) dclaimEventRecords!: Record<number, DamageClaimEvent>;
    @State({ default: {} }) pcertRecords!: Record<string, PcertItem>;
    @State({ default: {} }) pcertDetailsRecords!: Record<string, CertigrafPrecertificateData>;
    @State({ default: {} }) plotRecords!: Record<number, CertigrafPlot>;
    @State({ default: [] }) dclaimPhotos!: DamageClaimPhotos[];



    /**
     * Current dclaim selected
     */
    @State({ default: null }) selectedDclaim!: number | null;

    /**
     * Toggles
     */
    @State({ default: false }) showStepperModal!: boolean;
    @State({ default: false }) showNavbarFilters!: boolean;
    @State({ default: false }) disableMapSelectFunctionality!: boolean;

    /**
     *
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @State({ default: null }) tmpPlotData!: any | null;
    @State({ default: "" }) currentPlotName!: string;
    @State({ default: -1 }) currentPlotArea!: number;
    @State({ default: null }) currentPlotId!: number | null;

    /**
     * Dialog builder
     */
    @State({ default: null }) dialogOnCloseCallback!: () => void | null;
    @State({ default: null }) dialogOnAcceptCallback!: () => void | null;
    @State({ default: null }) dialogOnDenyCallback!: () => void | null;
    @State({ default: null }) dialogTitle!: string | null;
    @State({ default: null }) dialogContent!: string[] | null;
    @State({ default: false }) dialogOpen!: boolean;

    /**
     * Other
     */
    @State({ default: null }) selectedProduct!: ProductMap | null;
    @State({ default: null }) standardValueTotal!: number | null;
    @State({ default: null }) newPlotWkt!: string | null;

    /**
     *
     */
    @State({ default: -1 }) totalSelectedPlotsArea!: number;
    @State({ default: -1 }) totalSelectedAssuranceArea!: number;
    @State({ default: "" }) productFenologica!: string;
    @State({ default: null }) productSeedDate!: Date | null;
}

